import Stepper from '@mui/joy/Stepper'
import Step from '@mui/joy/Step'
import StepIndicator from '@mui/joy/StepIndicator'
import Check from '@mui/icons-material/Check'

export const StepProgress = ({ activeStep, steps }) => {
    const comps = steps.map((step, idx) => (
        <Step
            key={step}
            orientation="vertical"
            indicator={
                <StepIndicator
                    variant={activeStep <= idx ? 'soft' : 'solid'}
                    color={activeStep < idx ? 'neutral' : 'primary'}
                >
                    {activeStep <= idx ? idx + 1 : <Check />}
                </StepIndicator>
            }
        >
            {step}
        </Step>
    ))

    return <Stepper sx={{ width: '100%' }}>{comps}</Stepper>
}
